import React, { useEffect, useState } from "react";
import "./BlockchainTradingStats.css";
import useApi from "../../../helpers/apiHelper/requestHelper";

const BlockchainTradingStats = () => {
  const [data,setData] =useState({totalRecords:0,uniqueTraders:0,searchCount:0});
  const api=useApi();
  
  
  useEffect(()=>{
   async function fetchTradeStats(){

     const response=await api("get","/blockchain/stats");
     if(response?.status){
       setData(response.data)
      }
  }
  fetchTradeStats();
  },[])
  return (
    <>
      <div className="publicSearch">
        <div className="BlockchainTradingStats">
          <h2 className="title">Blockchain Powered Trading</h2> 

          <div className="statsCardWrapper">
              <div className="statsCard">
                <h4 className="cardTitle">Verified Trades</h4>
                <p className="cardNumber">{data?.totalRecords}</p>
              </div>
              <div className="statsCard">
              <h4 className="cardTitle">Traders</h4>
              <p className="cardNumber">{data?.uniqueTraders}</p>
            </div>
              <div className="statsCard">
              <h4 className="cardTitle">Trades Searched</h4>
              <p className="cardNumber">{data?.searchCount}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockchainTradingStats;
